module.exports = __webpack_public_path__ + "img/category_9.31abf42c.jpg";